import React from 'react';
import TextField from '../../../../Forms/TextField';
import ChoiceGroup from '../../../../Forms/ChoiceGroup';

const statOptions = [
    { key: 0, text: 'Off' },
    { key: 1, text: 'On' },
];

const AdvisorsForm = () => {
    return (
        <div className="mt-1">
            <TextField label="Title" placeholder="Enter Title" type="text" name="title" />
            <TextField
                label="Banner Description"
                placeholder="Enter description"
                type="text"
                name="bannerDescription"
            />
            <ChoiceGroup label="International On/Off" name="internationalOn" options={statOptions} />
            <ChoiceGroup label="On/Off Default" name="onOffDefault" options={statOptions} />
        </div>
    );
};

export default AdvisorsForm;
